module.exports = ".page-header {\n    margin-top: 0px;\n    color: #26273B;\n    border-bottom: none;\n    width: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/unsubscribe-user/unsubscribe-user.component.css
// module id = ./src/app/core/components/unsubscribe-user/unsubscribe-user.component.css
// module chunks = main